module.exports = __webpack_public_path__ + "img/gred.88e8fa4f.svg";